import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-mentions-legales',
    templateUrl: './mentions-legales.component.html',
    styleUrls: ['./mentions-legales.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MentionsLegalesComponent { }
